import { IonButton } from '@ionic/react';
import { FC } from 'react';
import { DuoFilePlusIcon } from '../../theme/Icons';

export type IAddNoteButtonProps = {
    canAdd: boolean;
    onClick: () => void;
    useIcon?: boolean;
    iconOnly?: boolean;
};

export const AddNoteButton: FC<IAddNoteButtonProps> = ({ canAdd, onClick, useIcon, iconOnly = false }) => {
    return (
        <IonButton
            fill="clear"
            color="primary"
            data-id="add-note-button"
            onClick={() => onClick()}
            style={{ display: canAdd ? 'block' : 'none' }}
        >
            {useIcon ? <DuoFilePlusIcon />: '+'}
            {!iconOnly && (
                <>&nbsp;Add Note</>
            )}
        </IonButton>
    );
};
